import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPage = styled.div`
  font-family: ${(props) => props.theme.fontText} !important;
  display: flex;
  flex-direction: column;
  overflow-x: clip;

  .layout {
    display: flex;
    flex-direction: column;
    padding-top: 0;
  }

  @media (max-width: ${breakpoints.lg}px) {
    .layout {
      padding-top: 0;
    }
  }

  .ant-layout-content {
    width: initial !important;
    min-height: 60vh;

    @media (max-width: ${breakpoints.xs}px) {
      min-height: auto;
    }
  }

  thead .ant-table-cell {
    background-color: ${(props) => props.theme.veryLightGray} !important;
    border-bottom: 1px ${(props) => props.theme.headerBottom} !important;
  }

  .ant-table-row:nth-child(even) {
    background-color: ${(props) => props.theme.veryLightGray};
  }

  .pagination ul {
    display: flex;
    align-items: center;

    .ant-pagination-item,
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-prev,
    .ant-pagination-next {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ant-pagination-item a {
      color: ${(props) => props.theme.paginationLink};
    }

    .ant-pagination-item-ellipsis {
      color: ${(props) => props.theme.paginationLink} !important;
      font-size: 10px;
    }

    @media only screen and (max-width: ${breakpoints.sm}px) {
      .ant-pagination-prev,
      .ant-pagination-next {
        margin-left: 5px;
        margin-right: 5px;
      }
      .ant-pagination-jump-next,
      .ant-pagination-jump-prev {
        margin-inline-end: 0;
      }
      .ant-pagination-item {
        min-width: unset;
      }
    }

    @media only screen and (max-width: ${breakpoints.xs}px) {
      .ant-pagination {
        align-items: center;
      }
      .ant-pagination-prev,
      .ant-pagination-next {
        margin-left: 0;
        margin-right: 0;
      }
      .ant-pagination-prev img,
      .ant-pagination-next img {
        width: 30px;
      }
      .ant-pagination-item {
        width: 30px !important;
        height: 30px !important;
      }
    }

    @media only screen and (max-width: 365px) {
      .ant-pagination-prev img,
      .ant-pagination-next img {
        width: 23px;
      }
      .ant-pagination-item {
        width: 23px !important;
        height: 23px !important;
      }
    }

    .ant-pagination-item-active {
      background-color: ${(props) => props.theme.paginationActiveBg};
      border: none;

      a {
        color: ${(props) => props.theme.white};
      }
    }

    li {
      .ant-pagination-item-link {
        width: 100%;
      }
      :has(.ant-pagination-item-ellipsis) {
        margin-top: 5px;
      }
      button span {
        color: ${(props) => props.theme.bgColorHover};
      }
    }
  }
`;
